import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const NavDropDownMenu = ({ menuTitle, items }) => {
  return (
    <li className="group dropdown lg:relative" title={menuTitle}>
      <button className="nav-btn">
        <span>{menuTitle}</span>
        <span className="ml-0.5">
          <FontAwesomeIcon icon={faCaretDown} />
        </span>
      </button>
      <div className="lg:fixed hidden lg:top-18 dropdown-menu">
        <ul>
          {items.map((item, idx) => (
            <li key={idx} title={item.title}>
              <a href={item.link}>{item.title}</a>
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};

export default NavDropDownMenu;
